import EsmModal from './EsmModal'
import EsmPrompt from './EsmPrompt'

export default {
    install(Vue) {
        Vue.component(EsmModal.name, EsmModal);
        const EsmPromptExtend = Vue.extend(EsmPrompt)
        Vue.prototype.$EsmPrompt = function (options = {}) {
            // 创建prompt实例
            const vm = new EsmPromptExtend().$mount()
            vm.show(options)
            // 关闭后销毁
            vm.$on('after-close', () => vm.$destroy())
            return vm
        }
    },
}
